var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2263 8.9286L9.83569 5.55946C9.62793 5.42963 9.36612 5.42276 9.15189 5.54149C8.93761 5.66022 8.80469 5.8859 8.80469 6.13086V12.8691C8.80469 13.1141 8.93761 13.3397 9.15189 13.4585C9.25368 13.5149 9.36617 13.543 9.47852 13.543C9.60263 13.543 9.72657 13.5087 9.83565 13.4406L15.2263 10.0714C15.4233 9.94828 15.543 9.73234 15.543 9.5C15.543 9.26767 15.4233 9.05173 15.2263 8.9286ZM10.1524 11.6534V7.34658L13.5978 9.5L10.1524 11.6534Z",
    fill: "#BEC0C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6309 0.740234H3.36914C1.5114 0.740234 0 2.25163 0 4.10938V14.8906C0 16.7484 1.5114 18.2598 3.36914 18.2598H19.6309C21.4886 18.2598 23 16.7484 23 14.8906V4.10938C23 2.25163 21.4886 0.740234 19.6309 0.740234ZM21.6523 14.8906C21.6523 16.0053 20.7455 16.9121 19.6309 16.9121H3.36914C2.25449 16.9121 1.34766 16.0053 1.34766 14.8906V4.10938C1.34766 2.99473 2.25449 2.08789 3.36914 2.08789H19.6309C20.7455 2.08789 21.6523 2.99473 21.6523 4.10938V14.8906Z",
    fill: "#BEC0C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromo);
export default __webpack_public_path__ + "static/media/promo.172d3f942ee8ae47663fa63646b88fef.svg";
export { ForwardRef as ReactComponent };